import React, { FunctionComponent } from 'react';
import { useFormik } from 'formik';
import { useSwipeable } from 'react-swipeable';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IProspectForm } from '../../../../common/models/prospect/IProspectForm';
import Input from '../../../../components/Input';
import Icon from '../../../../components/Icon';
import RegularButton from '../../../../components/RegularButton';

interface IInitValues {
  employer?: string;
  role?: string;
}

interface IProps {
  isPreview: boolean;
  referenceData: IInitValues;
  onConfirm: IBindingCallback1<IProspectForm>;
}

const ProspectForms: FunctionComponent<IProps> = ({
  isPreview,
  referenceData,
  onConfirm
}) => {
  const initialValues = {
    currentCompany: (!isPreview && referenceData.employer) || '',
    currentPosition: (!isPreview && referenceData.role) || '',
    profileLink: ''
  };

  const { handleSubmit, setFieldValue, values } = useFormik({
    initialValues,
    onSubmit: onConfirm
  });

  const swipeHandler = useSwipeable({
    onSwipedLeft: () => handleSubmit(),
    trackMouse: false
  });

  const isValid = Boolean(
    isPreview || values.currentCompany.trim() || values.currentPosition.trim() || values.profileLink.trim()
  );

  return (
    <div {...swipeHandler} className="survey-page">
      <form onSubmit={handleSubmit} autoComplete="off" className="survey-page-wrapper">
        <p className="survey-page-title">
          <FormattedMessage
            id="survey.prospectFormTitle"
            defaultMessage="Excellent! Can you please share a few final details with us?"
          />
        </p>
        <span>
          <FormattedMessage
            id="survey.noThankFormDescription"
            defaultMessage="Someone from our talent team may contact you."
          />
        </span>
        <div className="cf-form">
          <Input
            size="lg"
            type="text"
            onChange={val => setFieldValue('currentCompany', val)}
            label={{
              id: 'survey.prospectCompanyLabel',
              defaultMessage: 'Your current or most recent employer'
            }}
            placeholder={{
              id: 'survey.prospectCompanyPlaceholder',
              defaultMessage: 'Dunder Mifflin Paper Company'
            }}
            variant="underlined"
            value={values.currentCompany}
          />
          <Input
            size="lg"
            type="text"
            onChange={val => setFieldValue('currentPosition', val)}
            label={{
              id: 'survey.prospectRoleLabel',
              defaultMessage: 'Your current or most recent role'
            }}
            placeholder={{
              id: 'survey.prospectRolePlaceholder',
              defaultMessage: 'Assistant to the Regional Manager'
            }}
            variant="underlined"
            value={values.currentPosition}
          />
          <Input
            size="lg"
            type="text"
            onChange={val => setFieldValue('profileLink', val)}
            value={values.profileLink}
            label={{
              id: 'survey.prospectProfileLinkLabel',
              defaultMessage: 'LinkedIn or other professional profile'
            }}
            placeholder={{
              id: 'survey.prospectProfileLinkPlaceholder',
              defaultMessage: 'https://www.linkedin.com/in/yourname'
            }}
            variant="underlined"
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <RegularButton
            size="lg"
            textIntlId="done"
            defaultMessage="Done"
            variant="primary"
            onClick={handleSubmit}
            disabled={!isValid}
            icon={<Icon icon="arrowRight" />}
            iconPosition="right"
          />
        </div>
      </form>
    </div>
  );
};

export default ProspectForms;
